// extracted by mini-css-extract-plugin
module.exports = {"customBirthdateInput":"birthdate-input_customBirthdateInput__gEY00","calendarInputIcon":"birthdate-input_calendarInputIcon__MJPnI"};